<template>

  <v-dialog
    v-model="dialog"
    width="400"
    persistent
    class=""
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="white--text"
        color="blue darken-1"
        @click="dialog = true"
        :loading="loading"
        :disabled="disabled"
      >
        {{confirmationButton}}
      </v-btn>
    </template>

    <v-card>
      <v-card-title
        class="headline primary white--text"
        primary-title
      >
        Assinar Documento
      </v-card-title>

      <v-card-text>
        <span>
          Por favor, insira sua senha do SignGo para confirmar a assinatura do documento
        </span>
        <v-text-field
          label="Senha"
          v-model="password"
          type="password"
          persistent-hint
          hint='Senha de assinatura SignGo'
        />
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          flat
          @click="onCancel()"
        >
          Cancelar
        </v-btn>

        <v-btn
          class="white--text"
          color="blue darken-1"
          @click="onSuccess()"
        >
          Assinar
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>


</template>

<script>
  export default {
    name: 'RequestPasswordDialog',
    props: ['confirmationButton', 'loading', 'disabled'],
    data() {
      return {
        dialog: false,
        password: '',
      };
    },
    methods: {
      onSuccess() {
        this.$emit('onSuccess', {password: this.password});
        this.dialog = false;
      },
      onCancel() {
        this.$emit('onCancel', {});
        this.dialog = false;
      },
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/dialogs/RequestPasswordDialog.vue